module.exports = __webpack_public_path__ + "static/media/compass.d3bf33ff.png";